<template lang="pug">
  div
    divider(label="ANALISAR CREDENCIADO").margin-bottom-20.font-size
    div(v-if="solicitacaoCredenciado" v-loading="loading")
      validation-observer(ref='observer', tag='form', v-slot="{ handleSubmit }")
        form(@submit.prevent='handleSubmit(onSubmit)')
        .notificar
          el-dropdown(trigger='click' style='z-index: 9;')
            el-button.drop-opcoes Opções
              i.el-icon-arrow-down.el-icon--right
            el-dropdown-menu(slot='dropdown')
              el-dropdown-item(
                v-if="exibirRetificar()"
                icon='fas fa-sync-alt'
                @click.native="abrirModal('retificar')"
              )
                | Solicitar retificação
              el-dropdown-item(
                icon='far fa-comments'
                @click.native="abrirModal('notificar')"
              )
                |Notificar credenciado

        divider.margin-bottom-20(label="Dados pessoais")
        el-row(type="flex", :gutter="30")
          el-col(:span="4")
              span.label CPF:
              span {{ solicitacaoCredenciado.credenciado.pessoa.pessoaFisica.cpf || '-'}}
          el-col(:span="6")
              span.label Nome:
              span {{ solicitacaoCredenciado.credenciado.pessoa.pessoaFisica.nome || '-'}}
          el-col(:span="6")
            .telefone-container
              span.label Telefone(s):
              .telefone
                div(
                  v-if="solicitacaoCredenciado.credenciado.pessoa.telefones.length"
                  v-for="(tel, index) in solicitacaoCredenciado.credenciado.pessoa.telefones"
                  :key="index"
                )
                  span {{ tel.numero }}
                  span(v-if="index < solicitacaoCredenciado.credenciado.pessoa.telefones.length - 1") ,&nbsp

          el-col(:span="8")
              span.label E-mail:
              span {{ solicitacaoCredenciado.credenciado.pessoa.email || '-'}}
        divider.margin-bottom-20(label="Dados do credenciado")
        div(v-if="tipoEdital === 'GEOMENSOR'")
          el-row(type="flex", :gutter="40")
            el-col(:lg="6")
                span.label Registro no conselho:
                span {{ solicitacaoCredenciado.credenciado.codigoCrea || '-' }}
            el-col(:lg="6")
                span.label Formação:
                span {{ solicitacaoCredenciado.credenciado.formacao || '-'}}
            el-col(:lg="6")
                  span.label Código de credenciamento no INCRA:
                  span {{ solicitacaoCredenciado.credenciado.codigoIncra || '-'}}
        div(v-else)
          el-row(type="flex", :gutter="40")
            el-col(:lg="6")
                span.label Registro no conselho:
                span {{ solicitacaoCredenciado.credenciado.codigoCrea || '-' }}
            el-col(:lg="6")
                span.label Formação:
                span {{ solicitacaoCredenciado.credenciado.formacaoVistoriador || '-'}}
        divider.margin-bottom-20(label="Endereço")
        el-row(type="flex", :gutter="40")
          el-col(:lg="6")
            span.label Logradouro:
            span {{ solicitacaoCredenciado.credenciado.pessoa.endereco.logradouro || '-'}}
          el-col(:lg="6")
            span.label Número:
            span {{ solicitacaoCredenciado.credenciado.pessoa.endereco.numero || '-'}}
          el-col(:lg="6")
            span.label Bairro:
            span {{ solicitacaoCredenciado.credenciado.pessoa.endereco.bairro || '-'}}
          el-col(:lg="6")
            span.label Complemento:
            span {{ solicitacaoCredenciado.credenciado.pessoa.endereco.complemento || '-'}}
        el-row(type="flex", :gutter="40")
          el-col.margin-top-50(:lg="6")
            span.label CEP:
            span {{ solicitacaoCredenciado.credenciado.pessoa.endereco.cep || '-'}}
          el-col.margin-top-50(:lg="6")
            span.label Município:
            span {{ solicitacaoCredenciado.credenciado.pessoa.endereco.municipio.nome || '-'}}
          el-col.margin-top-50(:lg="6")
            span.label UF:
            span {{ solicitacaoCredenciado.credenciado.pessoa.endereco.municipio.codigoEstado || '-'}}
        divider.margin-bottom-20(label="Documentos")
        el-row
          el-col
            el-table.table(
            :data="solicitacaoCredenciado.credenciado.documentos"
            )
              template(slot="empty") Não foram encontradas solicitações com os dados informados
              el-table-column(
                label='Tipo de documento'
                prop='tipoDocumento.descricao'
              )
              el-table-column(
                label='Anexos'
              )
                template(slot-scope='scope')
                  el-tooltip(
                    v-if='scope.row.nome.length > 60'
                    :content="scope.row.nome"
                  )
                    span {{ scope.row.nome.substring(0, 60) + '...' }}
                  span(v-else) {{ scope.row.nome }}
              el-table-column(
                width="100"
                label="Ações"
              )
                template(slot-scope='scope')
                  .flex
                    app-action-button(
                      icone="fas fa-download",
                      @click="getDownload(scope.row)",
                      cor="#666666",
                      text="Baixar Documento"
                    )
        el-row.margin-top-50(:gutter="20" v-if='!isView')
          validation-provider(name='aprovar', :rules='{ required: !aprovar }', v-slot='{ errors }')
            el-radio-group.radio(v-model="aprovar")
              el-radio(:label="true") Aprovar credenciado
              el-radio(:label="false") Reprovar credenciado
            span.error(v-if="errors[0]") Para finalizar é obrigatório selecionar uma opção.
            div(v-if='!aprovar && aprovar !== null')
              divider(label="Justificativa da reprovação", tooltip="A justificativa da reprovação também será exibida ao solicitante.")
              el-input(
                type="textarea"
                :rows="5"
                placeholder="Informe a justificativa"
                v-model="textarea").box-shadow
      el-row.margin-top.footer(type="flex", justify="start")
        el-button(
          @click="voltar"
          class="voltarButton"
          v-if='isView'
        )
          i.fas.fa-arrow-left
          |  Voltar
        el-button(
          @click="cancelar"
          class="cancelarButton"
          v-if='!isView'
        )
          i.fas.fa-times
          |  Cancelar
        el-button(
          v-if='!isView'
          type='primary'
          @click="finalizar"
        )
          i.fas.fa-check
          |  {{'Finalizar'}}

      modal-notificar(
        v-if='showModalNotificar'
        :modalOpen='showModalNotificar'
        :solicitacao='solicitacaoCredenciado'
        :idSolicitacao='this.$route.params.idSolicitacaoCredenciado'
        :dataFimEdital="dataFimEdital"
        @close-modal='showModalNotificar = false'
      )

      modal-retificar(
        v-if='showModalRetificar'
        :modalOpen='showModalRetificar'
        :solicitacao='solicitacaoCredenciado'
        :dataFimEdital="dataFimEdital"
        @close-modal='showModalRetificar = false'
        @retificar='retificar'
      )

</template>

<script>
import AppActionButton from '@/components/AppActionButton';
import FileSaver from 'file-saver';
import { findById, validar } from '@/services/solicitacaoCredenciadoService';
import { findByCaminho } from '@/services/documentoService';
import { Divider, AppNotificacao } from 'sicarf-components';
import situacoes from '@/constants/situacoes';
import ModalNotificar from '@/components/modalNotificar';
import ModalRetificar from '@/components/modalRetificar';

export default {

  data() {
    return {
      showModalNotificar: false,
      showModalRetificar: false,
      solicitacaoCredenciado: null,
      aprovar: null,
      idSolicitacao: null,
      idEdital: '',
      tipoEdital: '',
      loading: false,
      isView: false,
      textarea: '',
      dataFimEdital: new Date()
    }
  },
  components: {
    Divider,
    AppActionButton,
    ModalNotificar,
    ModalRetificar,
  },
  mixins: [
    AppNotificacao
  ],
  async mounted() {
    this.loading = true;
    this.idSolicitacao = this.$route.params.idSolicitacaoCredenciado;
    this.idEdital = this.$route.params.idEdital;
    this.solicitacaoCredenciado = await findById(this.idSolicitacao);
    this.tipoEdital = this.solicitacaoCredenciado.edital.tipoEdital
    if (this.solicitacaoCredenciado?.edital?.dataFim) {
      this.dataFimEdital = new Date(this.solicitacaoCredenciado?.edital?.dataFim)
    }
    if (this.solicitacaoCredenciado.situacao !== situacoes.AGUARDANDO_APROVACAO) {
      this.isView = true;
    }

    this.loading = false;
  },
  methods: {
    async getDownload (documento) {
      const resp = await findByCaminho(documento.caminho);
      const file = new Blob([resp])
      FileSaver.saveAs(file, documento.nome)
    },
    async finalizar() {
      let dto = {
        id: this.idSolicitacao,
        aprovar: this.aprovar,
      }
      if (!this.aprovar) {
        dto.justificativa = this.textarea
      }
      let isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.loading = true;
        await validar(dto);
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.VALIDACAO_SUCESSO
        )
        this.$router.push({
          name: 'solicitacoes/listagem',
        });
      } else {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.ERRO_VALIDACAO_FINALIZAR_VALIDACAO
        )
      }
      this.loading = false;
    },
    cancelar () {
      this.confirmBox('Ao cancelar, todos os dados serão perdidos. Deseja confirmar esta ação?', this.$messages.TITULO_WARNING,
        () => {
          this.$router.push({
            name: 'solicitacoes/listagem',
          });
        },
        () => {}
      )
    },
    voltar() {
      this.$router.push({
        name: 'solicitacoes/listagem',
      });
    },
    exibirRetificar() {
      if (this.solicitacaoCredenciado.situacao !== situacoes.APROVADO &&
        this.solicitacaoCredenciado.situacao !== situacoes.REPROVADO) {
        return true;
      }
      return false;
    },
    abrirModal(action) {
      if (action === 'notificar') {
        this.showModalNotificar = true
      } else {
        this.showModalRetificar = true
      }
    },
    retificar() {
      this.showModalRetificar = false;
      this.voltar();
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/_variables.scss";
.card-header {
  margin-bottom: 20px;
}

.align-center{
  align-content: center;
}

.label{
  margin-right: 10px;
}

.select {
  width:100%
}

.radio {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.margin-bottom-20 {
  margin-bottom: 20px;
}

.margin-top-50 {
  margin-top: 50px;
}

.container-cadastro {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.el-icon-search {
  color: #009f61;
}

span::v-deep .el-input__count-inner {
  color:#009f61
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance:textfield;
}

.cancelarButton:hover, .cancelarButton:focus {
  background-color:#fef0f0;
  color: #f56c6c;
  border-color: #fbc4c4;
}

.voltarButton:hover, .voltarButton:focus {
  color: #009f61;
  border-color: #009f61;
}

.drop-opcoes {
  background-color: #009f61;
  color: #fff;
  z-index: 9;
}

.paddingLeft10 {
  padding-left: 10px;
}

.notificar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: -70px;
}

.justify {
  display: flex;
  flex-direction: row;
}

.error {
  display: flex;
  justify-content: center;
}

.box-shadow{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.telefone-container {
  display: flex;
  flex-direction: row;
}

.telefone {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  flex-wrap: wrap;
}
</style>
